import { Box, Avatar, Typography, Badge } from "@mui/material";
import WifiRoundedIcon from "@mui/icons-material/WifiRounded";
import { Link } from "react-router-dom";

const OnlineFriends = ({ onlineUsers }) => {
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <WifiRoundedIcon sx={{ color: "#D4AF37", fontSize: 16 }} />
        <Typography sx={{ fontWeight: 700, fontSize: 13, color: "#1F2937" }}>
          Online now
        </Typography>
        <Box
          sx={{
            ml: "auto",
            bgcolor: "#22C55E",
            color: "#fff",
            fontSize: 10,
            fontWeight: 700,
            px: 0.8,
            py: 0.2,
            borderRadius: "20px",
            lineHeight: 1.4,
          }}
        >
          {onlineUsers.length}
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
        {onlineUsers.length > 0 ? (
          onlineUsers.map((user) => {
            const initials = `${user.firstName?.[0] ?? ""}${user.lastName?.[0] ?? ""}`.toUpperCase();
            return (
              <Link
                key={user._id}
                to={`/profile/${user._id}`}
                style={{ textDecoration: "none" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    px: 0.8,
                    py: 0.7,
                    borderRadius: "9px",
                    transition: "background 0.15s",
                    "&:hover": { bgcolor: "rgba(212,175,55,0.09)" },
                  }}
                >
                  <Badge
                    variant="dot"
                    sx={{
                      flexShrink: 0,
                      "& .MuiBadge-dot": {
                        width: 9,
                        height: 9,
                        bgcolor: "#22C55E",
                        borderRadius: "50%",
                        top: 3,
                        right: 1,
                        border: "1.5px solid #fff",
                        minWidth: "unset",
                      },
                    }}
                  >
                    <Avatar
                      src={user.profilePicture}
                      sx={{
                        width: 32,
                        height: 32,
                        bgcolor: "#D4AF37",
                        color: "#1A1A2E",
                        fontSize: 11,
                        fontWeight: 700,
                      }}
                    >
                      {initials}
                    </Avatar>
                  </Badge>
                  <Typography
                    noWrap
                    sx={{
                      fontSize: 12.5,
                      fontWeight: 600,
                      color: "#1F2937",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: 0,
                    }}
                  >
                    {user.firstName} {user.lastName}
                  </Typography>
                </Box>
              </Link>
            );
          })
        ) : (
          <Typography sx={{ textAlign: "center", color: "#9CA3AF", fontSize: 12.5, py: 2 }}>
            No one online
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default OnlineFriends;
